import { Keyboard, Platform } from "~/ui/primitives"

/** Web 上点击空白处不应 dismiss，否则会与 TextInput 聚焦冲突 */
export function dismissKeyboard() {
  if (Platform.OS !== "web") {
    Keyboard.dismiss()
  }
}

export const dismissKeyboardOnPress = Platform.OS !== "web" ? Keyboard.dismiss : undefined
